export default "__VITE_ASSET__50881364__"